import React from 'react';
import PropTypes from 'prop-types';

import ContactFormModal from '../../ContactSupportBanner/ContactFormModal';
import NoResultsImage from '../../../../assets/images/no-results-search.svg';

function NoSearchResults(props) {
  return (
    <div className="no-results-container">
      <img alt="no-results" src={NoResultsImage} />
      <h3>0 profiles matching your criteria.</h3>
      <p>Clora can assist you with any need. Add a project and we will send you candidates.</p>
      <div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            window.location.href = '/projects/add_project';
          }}
        >
          <i className="fas fa-plus" />
          Add Project
        </button>
        <ContactFormModal
          {...props}
        />
      </div>
    </div>
  );
}

NoSearchResults.propTypes = {
  csrfToken: PropTypes.string.isRequired,
};

export default NoSearchResults;
